import axios from 'axios';

export const patchSwrFetcherWithDynamicUrl = async <T, R>(url: string, { arg }: { arg: T & { urlSuffix: string } }) => {
  const { urlSuffix, ...restArg } = arg;

  // TODO: do better, appending part of a url is a bit of a hack for now. The confusing part that I didn't crack yet was to make TS happy..
  const response = await axios.patch<R>(`${url}${urlSuffix}`, restArg);

  return response.data;
};
